import { NgModule } from '@angular/core';
import { DigitOnlyDirective } from './digit-only.directive';

@NgModule({
  imports: [],
  declarations: [DigitOnlyDirective],
  exports: [DigitOnlyDirective],
})
export class DigitOnlyModule {}